let measurmentType = "cm"
let size = 0
let bodyPart = "bust"



let sizeGuideTable = {
    "bust" : {
        "cm" : ["84","87-90","92-94","98-104","106-109","112-116"],
        "in": ["30-31-32","33-34","35-37","39-41","43","46"]
    },
    "underbust": {
        "cm" : ["66-68","71-73","76-78","81-83"],
        "in": ["26-27","28-29","30-31","32-33"]
    },
    "waist":{
        "cm" : ["61-64","66-69","71-74","77-81","85-92","97-102"],
        "in": ["24-25","26-27","28-29","31-32","34-36","38-40"]
    },
    "hips":{
        "cm" : ["84-87","92-94","100-104","109-112","114-119","124-130"],
        "in": ["33-34","36-37","39-41","43-44","45-47","49-51"]
    }
}





document.querySelectorAll('.singlePart').forEach(item => {
    item.addEventListener('click', event => {
       var panel = item.nextElementSibling;
      if (panel.style.display === "block") {
        item.classList.remove("active");
        panel.style.display = "none";
      } else {
        item.classList.add("active");
        panel.style.display = "block";
      }
        bodyPart = item.innerHTML.toLowerCase()
        getSizeBasedOnInfo(measurmentType,size,bodyPart);
    })
  })

document.querySelectorAll('.typeOfMeasurement').forEach(item => {
item.addEventListener('click', event => {
    measurmentType = item.innerHTML.toLowerCase()
    getSizeBasedOnInfo(measurmentType,size,bodyPart)
})
})


function sizeChange(selectedSize){
    size = selectedSize
    getSizeBasedOnInfo(measurmentType,size,bodyPart)
}
  

function getSizeBasedOnInfo(measurmentType,size,bodyPart){
  var measurement = document.querySelector('.measurement')
    measurement.innerHTML = sizeGuideTable[`${bodyPart}`][`${measurmentType}`][size];
}

getSizeBasedOnInfo(measurmentType,size,bodyPart)


  function openImage(evt, locationImage) {
    var i, tabcontent, tablinks;
    tabcontent = document.getElementsByClassName("tabcontent");
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }
    tablinks = document.getElementsByClassName("tablinks");
    document.getElementById(locationImage).style.display = "block";
  }
      